import { useEffect, useState } from "react";
import AdminLayout from "./AdminLayout";
import {
  getPlatformConfig,
  setWaitlistOpen,
} from "../../services/platformConfigService";

export default function AdminSettings() {
  const [waitlistOpen, setWaitlistOpenState] = useState(true);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    let alive = true;
    getPlatformConfig()
      .then((cfg) => {
        if (alive) setWaitlistOpenState(cfg?.waitlistOpen !== false);
      })
      .catch((err) => {
        if (alive) setError(err.message || "Failed to load config.");
      });
    return () => {
      alive = false;
    };
  }, []);

  const toggle = async () => {
    try {
      setBusy(true);
      setError("");
      setSaved(false);
      const next = !waitlistOpen;
      await setWaitlistOpen(next);
      setWaitlistOpenState(next);
      setSaved(true);
    } catch (err) {
      setError(err.message || "Failed to update waitlist flag.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <AdminLayout>
      <div className="admin-page-header">
        <div className="admin-eyebrow">Platform</div>
        <div className="admin-page-title">Settings</div>
        <span className="admin-page-hand">— waitlist and platform flags</span>
      </div>

      <div
        style={{
          marginTop: 28,
          maxWidth: 480,
          padding: 20,
          background: "#fff",
          border: "1px solid #DDD8CE",
          borderRadius: 12,
        }}
      >
        <div style={{ fontSize: 13, fontWeight: 700, marginBottom: 8 }}>Waitlist open</div>
        <p style={{ fontSize: 13, color: "#9A9088", lineHeight: 1.5, marginBottom: 16 }}>
          When open, new fans/creators enter the waitlist queue. When closed, signup can go live
          (post-launch path).
        </p>
        <button
          type="button"
          className="admin-btn admin-btn-niche"
          disabled={busy}
          onClick={toggle}
        >
          {waitlistOpen ? "Waitlist is OPEN — click to close" : "Waitlist is CLOSED — click to open"}
        </button>
        {saved && (
          <p style={{ marginTop: 12, fontSize: 12, color: "#1A8C52" }}>Saved.</p>
        )}
        {error && (
          <p style={{ marginTop: 12, fontSize: 12, color: "#D03050" }}>{error}</p>
        )}
      </div>
    </AdminLayout>
  );
}
